import { ActivityCall } from "../api/request";

function FireAnalyticsEvent(event, eventData) {
  const GAintervalId = setInterval(() => {
    if (window?.gtag) {
      clearInterval(GAintervalId);
      window.gtag("event", event, eventData);
    }
  }, 1000);
}

function FireTealiumEvent(event, eventData, isViewEvent = false) {
  const TealiumIntervalId = setInterval(() => {
    if (window?.utag) {
      clearInterval(TealiumIntervalId);
      if (isViewEvent) {
        window.utag.view({
          ...eventData,
        });
      } else {
        window.utag.link({
          tealium_event: event,
          ...eventData,
        });
      }
    }
  }, 1000);
}

function SendNFTEvents(jsonData) {
  const {
    to_pass: { answer_history },
    to_use: { skus },
  } = jsonData;

  const currentQuestionIndex = answer_history.length;
  const hangUUID = sessionStorage.getItem("hUId");
  const isiFrame = window.location.search.includes("source=iframe")
    ? true
    : false;
  const queryParams = isiFrame
    ? window.parent.location.search
    : window.location.search;
  const queryParamsValues = new URLSearchParams(queryParams);
  const userId = queryParamsValues.has("hUId") && queryParamsValues.get("hUId");

  if (userId && userId !== hangUUID) {
    sessionStorage.setItem("hUId", userId);
  }
  let actionId;
  // Made an API only if the hUId is present in the URL
  if (userId) {
    if (answer_history.length === 1) {
      // Means the quiz is just started
      actionId = "QS";
      ActivityCall(userId, actionId);
    } else if (answer_history.length > 1 && !skus.length) {
      // Means the quiz is in progress
      actionId = `Q${currentQuestionIndex}`;
      ActivityCall(userId, actionId);
    } else if (skus.length) {
      // Once the quiz is completed, send last question event and then send quiz finish event
      actionId = `Q${currentQuestionIndex}`;
      ActivityCall(userId, actionId);
      // Means the quiz is completed
      actionId = "QF";
      ActivityCall(userId, actionId);
    }
  }
}

export { FireAnalyticsEvent, SendNFTEvents, FireTealiumEvent };
